import React from 'react';

import { SimpleGrid, Stack, Title, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { AthletePackageRetrieve } from 'types';

import AthletePackageHoldsCard from './components/AthletePackageHoldsCard';
import BillingSummaryCard from './components/BillingSummaryCard';
import CreditValueCard from './components/CreditValueCard';
import PackageSummaryCard from './components/PackageSummaryCard';

interface ISummaryTabProps {
  athletePackage: AthletePackageRetrieve;
  setAthletePackageId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const SummaryTab1 = ({ athletePackage, setAthletePackageId }: ISummaryTabProps): JSX.Element => {
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.sm}`, false);

  return (
    <Stack>
      <Title order={3}>Summary</Title>
      <SimpleGrid cols={isDesktop ? 2 : 1}>
        <div>
          <PackageSummaryCard athletePackage={athletePackage} setAthletePackageId={setAthletePackageId} />
        </div>
        {athletePackage.athletePackageHolds.length > 0 && (
          <div>
            <div>
              <AthletePackageHoldsCard athletePackage={athletePackage} />
            </div>
            {!!athletePackage.creditValue && (
              <div style={{ marginTop: '1rem' }}>
                <CreditValueCard creditValue={athletePackage.creditValue} />
              </div>
            )}
          </div>
        )}
        <div>
          <BillingSummaryCard athletePackage={athletePackage} />
        </div>
        {!!athletePackage.creditValue && athletePackage.athletePackageHolds.length <= 0 && (
          <div>
            <CreditValueCard creditValue={athletePackage.creditValue} />
          </div>
        )}
      </SimpleGrid>
      <div />
    </Stack>
  );
};

export default SummaryTab1;
